import { render, staticRenderFns } from "./UnregisteredِِAgent.vue?vue&type=template&id=227d0e7a&scoped=true"
import script from "./UnregisteredِِAgent.vue?vue&type=script&lang=js"
export * from "./UnregisteredِِAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227d0e7a",
  null
  
)

export default component.exports